import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class AlertService {
  private subject = new BehaviorSubject<any>(null);

  private showInModal = new BehaviorSubject<boolean>(false);
  readonly showInModal$ = this.showInModal.asObservable();
  private keepAfterNavigationChange = false;

  constructor(private router: Router) {
    // clear alert message on route change
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
        } else {
          // clear alert
          this.clear();
        }
      }
    });
  }

  // ? these functions might be more usable with options objects instead of individual params

  success(
    message: string,
    keepAfterNavigationChange = false,
    target = 'app-modal-alert',
    timeout = 4,
    canDismiss = false
  ): void {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.checkTarget(target);
    this.subject.next({
      type: 'success',
      text: message,
      target,
      timeout,
      canDismiss,
    });
    if (timeout) {
      setTimeout(() => {
        this.subject.next({ target, type: 'success' });
      }, timeout * 1000); // timeout in seconds
    }
  }

  clear(messages?: any[]): void {
    const target = 'app-modal-alert';
    this.subject.next({ target });
    if (messages?.length === 0 || !messages) {
      this.subject.next({ target });
    } else {
      this.subject.next(messages);
    }
  }

  error(
    message: string,
    keepAfterNavigationChange = false,
    target = 'app-modal-alert',
    canDismiss = true
  ): void {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.checkTarget(target);
    this.subject.next({ type: 'error', text: message, target, canDismiss });
  }

  warning(
    message: string,
    keepAfterNavigationChange = false,
    target = 'app-modal-alert',
    canDismiss = false
  ): void {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.checkTarget(target);
    this.subject.next({ type: 'warning', text: message, target, canDismiss });
  }
  checkTarget(target) {
    if (target === 'app-modal-alert.fixedPageAlert') {
      this.showInModal.next(true);
    } else {
      this.showInModal.next(false);
    }
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
